import * as Status from '../constants/status';
import * as Role from '../constants/role';
import { NSIR_DIGITACAO_ANTECIPADA } from '../constants/modules';
import { hasModuleConfiguration } from './moduleConfigurationPermission';
import { isUsuarioSupervisor } from './inspecaoReportPermission';
import { isInspecaoMtBt, isUsoMutuo, isTrue } from '../utils';

export const INSPECTION_FIELD_STATUSES = [
  Status.EM_INSPECAO,
  Status.INSPECAO_ENVIADA_PARCIAL,
  Status.INSPECAO_EM_ENVIO,
];

export const isInspectionFieldStatus = (status) =>
  INSPECTION_FIELD_STATUSES.includes(status);

export const isTipoServicoDigitacaoAntecipada = (tipoServicoId) =>
  isUsoMutuo(tipoServicoId) || isInspecaoMtBt(tipoServicoId);

const isUsoMutuoNewFlow = (tipoServicoId, newFlow) =>
  !isUsoMutuo(tipoServicoId) || isTrue(newFlow);

export const isDigitacaoAntecipadaAtiva = ({ digitacaoAntecipada, status } = {}) =>
  Boolean(digitacaoAntecipada) && isInspectionFieldStatus(status);

export const canLiberarDigitacaoAntecipada = ({ authData, moduleConfigurations } = {}) =>
  authData?.role === Role.SUPER_ADMIN
  || isUsuarioSupervisor(authData)
  || hasModuleConfiguration(moduleConfigurations, authData, NSIR_DIGITACAO_ANTECIPADA);

export const isDigitacaoHabilitada = ({
  status,
  digitadorId,
  userId,
  userRole,
  digitacaoAntecipada,
} = {}) => {
  if (userRole !== Role.DIGITADOR || !digitadorId || !userId || digitadorId !== userId) {
    return false;
  }
  if (status === Status.EM_DIGITACAO) return true;
  return isDigitacaoAntecipadaAtiva({ digitacaoAntecipada, status });
};

export const canShowLiberarDigitacaoAntecipada = ({
  authData,
  moduleConfigurations,
  status,
  tipoServicoId,
  digitacaoAntecipada,
  newFlow,
} = {}) =>
  canLiberarDigitacaoAntecipada({ authData, moduleConfigurations })
  && isTipoServicoDigitacaoAntecipada(tipoServicoId)
  && isUsoMutuoNewFlow(tipoServicoId, newFlow)
  && isInspectionFieldStatus(status)
  && !digitacaoAntecipada;

export const canShowRevogarDigitacaoAntecipada = ({
  authData,
  moduleConfigurations,
  status,
  tipoServicoId,
  digitacaoAntecipada,
  newFlow,
} = {}) =>
  canLiberarDigitacaoAntecipada({ authData, moduleConfigurations })
  && isTipoServicoDigitacaoAntecipada(tipoServicoId)
  && isUsoMutuoNewFlow(tipoServicoId, newFlow)
  && isInspectionFieldStatus(status)
  && Boolean(digitacaoAntecipada);

export const getDigitacaoAntecipadaOverlay = ({
  digitacaoAntecipada,
  status,
  digitados,
  total,
  totalServicos,
} = {}) => {
  if (!isDigitacaoAntecipadaAtiva({ digitacaoAntecipada, status })) return null;
  const done = Number(digitados);
  const denomRaw = total ?? totalServicos;
  const denom = Number(denomRaw);
  const hasProgress = Number.isFinite(done) && done > 0;
  if (hasProgress) {
    const label = Number.isFinite(denom) && denom > 0
      ? `Digitando ${done}/${denom}`
      : 'Digitando';
    return { label, value: 'DIGITANDO_ANTECIPADA' };
  }
  return { label: 'Liberada p/ digitação', value: 'LIBERADA_DIGITACAO_ANTECIPADA' };
};

export const toDigitacaoAntecipadaApiFlag = (value) => {
  if (value === true || value === 'true') return true;
  if (value === false || value === 'false') return false;
  return undefined;
};
